export default "__VITE_ASSET__DcrUZ6Xe__"